var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company_wrap"},[(_vm.noAuthencation)?_c('NotAct'):_c('FarenHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }